export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getBusinessList: function getBusinessList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/business/get",
        method: "get",
        params: data
      });
    },
    addBusiness: function addBusiness() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/business/add",
        method: "post",
        data: data
      });
    },
    updateBusiness: function updateBusiness() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/business/update",
        method: "post",
        data: data
      });
    },
    deleteBusiness: function deleteBusiness() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/business/delete",
        method: "post",
        data: data
      });
    },
    getBusinessListV3: function getBusinessListV3() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/business/list",
        method: "get",
        params: data
      });
    },
    deleteBusinessV3: function deleteBusinessV3(id) {
      return request({
        url: "/api/v3/admin/business/delete/".concat(id),
        method: "post"
      });
    },
    addBusinessV3: function addBusinessV3() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/business/add",
        method: "post",
        data: data
      });
    },
    updateBusinessV3: function updateBusinessV3() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/business/update",
        method: "post",
        data: data
      });
    },
    updateBusinessAOIV3: function updateBusinessAOIV3() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/business/updateLocation",
        method: "post",
        data: data
      });
    },
    //更新排序
    updateBusinessOrderV3: function updateBusinessOrderV3() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/business/updateOrder",
        method: "post",
        data: data
      });
    }
  };
});